<template>
  <NuxtLayout name="basic" class="flex-center">
    <div class="max-w-450px mx-auto">
      <AlertDialog
        icon="material-symbols:search-off"
        title="Page not found"
      >
        <template #subtitle>
          The page <b>{{ $route.path }}</b> you are looking for does not exist.
          <br>
          If you think this is an error please contact us.
        </template>
      </AlertDialog>

      <a href="https://vocal.email">
        <CTAButton class="mt-6 !rounded-full" size="md">
          Go to homepage
        </CTAButton>
      </a>
    </div>
  </NuxtLayout>
</template>
